import { render } from "./ListFeedbackPage.vue?vue&type=template&id=52489a2e&ts=true"
import script from "./ListFeedbackPage.vue?vue&type=script&lang=ts"
export * from "./ListFeedbackPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__